"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = __importDefault(require("vue"));
exports.default = vue_1.default.extend({
    name: 'icon-minus',
    props: {
        min: [String, Number],
        value: Number,
        step: {
            type: [String, Number],
            default: 1,
        },
    },
    methods: {
        decrement() {
            const min = Number(this.min === null ? undefined : this.min);
            if (isNaN(min) || this.value - +this.step >= min) {
                this.$emit('input', this.value - +this.step);
            }
        }
    }
});
